<div class="fb-default-field-wrapper w-full">
  <div class="fb-field-label-container" *ngIf="!noLabel">
    <label
      class="fb-field-label"
      *ngIf="label"
      [class.disable-label]="disable && (_currentThemeSubject | async) === 'dark'"
    >
      {{ label }}
      <span class="required-asterisk" *ngIf="required">*</span>
    </label>
  </div>

  <div class="d-flex align-items-center picker-wrapper">
    <mat-form-field
      [appearance]="defaultAppearance || 'outline'"
      floatLabel="always"
      class="w-full date-picker-field fb-custom-outline"
      [class.is-invalid]="formControl.invalid && (formControl.touched || formControl.dirty)"
      [class.is-filled]="formControl.value"
    >
      <mat-label class="d-none"></mat-label>

      <fb-anex
        *ngIf="prefix"
        matPrefix
        [config]="prefix"
        [control]="control"
        [templates]="templates"
        position="start"
      ></fb-anex>

      <input
        matInput
        [owlDateTimeTrigger]="picker"
        [owlDateTime]="picker"
        [formControl]="formControl"
        fbDisableAutocomplete
        [placeholder]="placeholder || ''"
        [required]="required"
        [minlength]="minLength"
        [maxlength]="maxLength"
        [readonly]="true"
        min="{{ min !== undefined ? min : min }}"
        [max]="maxDate || undefined"
        [fbDisableControl]="disable"
        (focusout)="onTouched()"
        [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
        [class.light-theme]="(_currentThemeSubject | async) === 'light'"
        class="date-input"
      />
      <button
        *ngIf="formControl.value && withReset"
        tabindex="-1"
        class="reset-button"
        type="button"
        mat-icon-button
        matSuffix
        (click)="onClear(); $event.stopPropagation(); $event.preventDefault()"
        [disabled]="disable || readonly"
      >
        <mat-icon [inline]="true">clear</mat-icon>
      </button>
      <ng-container *ngIf="(loading.active$ | async) === false; else showLoader">
        <ng-container>
          <fb-anex
            *ngIf="suffix; else showToggle"
            matSuffix
            [config]="suffix"
            [control]="control"
            [templates]="templates"
            position="end"
          ></fb-anex>
        </ng-container>
        <ng-template #showToggle>
          <mat-datepicker-toggle matPrefix tabindex="-1" [owlDateTimeTrigger]="picker" class="date-picker-toggle">
            <mat-icon
              matDatepickerToggleIcon
              class="c-pointer picker-toggle icon-button"
              [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
              [class.light-theme]="(_currentThemeSubject | async) === 'light'"
              [svgIcon]="'fleet-management'"
            >
            </mat-icon>
          </mat-datepicker-toggle>
        </ng-template>
      </ng-container>
      <ng-template #showLoader>
        <fb-loader class="position-relative loader" [size]="20" [message]="undefined" matSuffix></fb-loader>
      </ng-template>
      <owl-date-time
        [pickerType]="'calendar'"
        #picker
        [panelClass]="['green-theme-picker', (_currentThemeSubject | async) === 'dark' ? 'darkPicker' : 'lightPicker']"
      ></owl-date-time>
    </mat-form-field>
    <ng-container *ngIf="withArrows && formControl.value">
      <button
        type="submit"
        mat-button
        class="arrow-btn left t-footnote-semibold"
        [class.b-greyscale-500]="(_currentThemeSubject | async) === 'dark'"
        [class.b-light-stroke]="(_currentThemeSubject | async) === 'light'"
        [class.dark-theme-bg-color]="(_currentThemeSubject | async) === 'dark'"
        [class.light-theme-bg-color]="(_currentThemeSubject | async) === 'light'"
        (click)="onSwitch('left'); $event.preventDefault()"
      >
        <mat-icon fontSet="material-symbols-outlined" class="arrow-icon">chevron_left</mat-icon>
      </button>
      <button
        type="submit"
        mat-button
        class="arrow-btn right t-footnote-semibold"
        [class.b-greyscale-500]="(_currentThemeSubject | async) === 'dark'"
        [class.b-light-stroke]="(_currentThemeSubject | async) === 'light'"
        [class.dark-theme-bg-color]="(_currentThemeSubject | async) === 'dark'"
        [class.light-theme-bg-color]="(_currentThemeSubject | async) === 'light'"
        (click)="onSwitch('right'); $event.preventDefault()"
      >
        <mat-icon fontSet="material-symbols-outlined" class="add-icon">chevron_right</mat-icon>
      </button>
    </ng-container>
  </div>

  <div class="fb-field-subscript">
    <fb-validation-error
      *ngIf="formControl.invalid && (formControl.touched || formControl.dirty)"
      [control]="formControl"
      [label]="label"
    ></fb-validation-error>
  </div>
</div>
